let _validateObjectorHelper = {
  councilId: {
    required: true,
    hasError: false,
    helperText: "Select the LGA your property is located within",
    type: "select",
    fieldName: "Council",
    errorText: "",
  },
  assessmentNumber: {
    required: true,
    hasError: false,
    helperText: "Council assessment number of property",
    type: "fixedLength",
    fieldName: "Assessment number",
    errorText: "",
    length: 100,
  },
};

class ValidateObjectorHelper {
  getValidateObjectorHelper() {
    return _validateObjectorHelper;
  }

  getFieldDetail(field) {
    let value = _validateObjectorHelper[field];
    return value;
  }
}

// we need to instantiate the store
const validateObjectorHelper = new ValidateObjectorHelper();

export default validateObjectorHelper;
